import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { useContext, useState } from "react";
import DashboardContext from "../../../../contexts/DashboardContext";
import { Button } from "@sw-sw/lib-ui";
import { toZonedTime } from 'date-fns-tz';
import _ from "lodash";

const SideFilterMenu = (props: any) => {
  const { tabName, setSelectedOverdueThreshold, setSelectedRegionValue, setSelectedDivisionValue } = props;
  const [open, setOpen] = useState(false);

  const {
    regionListForCM,
    divisionListForCM,
    queryParamsForRegionsTab,
    setqueryParamsForRegionsTab,
    setqueryParamsForDivisionalSpecificsCM,
    findingTypeListForCM,
    inspectionTypeListForCM,
    projectTypeListForDashboardTabs
  } = useContext(DashboardContext);

  // Local states for controlled selects
  const [division, setDivision] = useState("All Divisions");
  const [region, setRegion] = useState("All Regions");
  const [project, setProject] = useState("All Project Types");
  const [finding, setFinding] = useState("All Finding Types");
  const [inspection, setInspection] = useState("All Inspection Types");
  const [dateRange, setDateRange] = useState("Year to Date");
  const defaultFindingThresholdNumberOfDays = 7;
  const [, setFindingThresholdNumberOfDays] = useState(defaultFindingThresholdNumberOfDays);
  const currentYear = new Date().getFullYear();
  const today = new Date();
  let dateRangeList= {
    [`Q1 - ${currentYear}`]: {
      minDate: toZonedTime(new Date(`${currentYear}-01-01T00:00:00.000Z`), 'UTC'),
      maxDate: toZonedTime(new Date(`${currentYear}-03-31T23:59:59.999Z`), 'UTC'),
    },
    [`Q2 - ${currentYear}`]: {
      minDate: toZonedTime(new Date(`${currentYear}-04-01T00:00:00.000Z`), 'UTC'),
      maxDate: toZonedTime(new Date(`${currentYear}-06-30T23:59:59.999Z`), 'UTC'),
    },
    [`Q3 - ${currentYear}`]: {
      minDate: toZonedTime(new Date(`${currentYear}-07-01T00:00:00.000Z`), 'UTC'),
      maxDate: toZonedTime(new Date(`${currentYear}-09-30T23:59:59.999Z`), 'UTC'),
    },
    [`Q4 - ${currentYear}`]: {
      minDate: toZonedTime(new Date(`${currentYear}-10-01T00:00:00.000Z`), 'UTC'),
      maxDate: toZonedTime(new Date(`${currentYear}-12-31T23:59:59.999Z`), 'UTC'),
    },
  }

  dateRangeList = Object.fromEntries(
    Object.entries(dateRangeList).filter(([, value]) => {
      return value.minDate <= today;
    })
  )

  // Handlers for controlled components
  const handleDivisionSelect = (event: any) => {
    const value = event.target.value;

    setDivision(value);
    setSelectedDivisionValue(value)
    setqueryParamsForDivisionalSpecificsCM({ divisionFilter: value });
  };

  const handleRegionSelect = (event: any) => {
    const value = event.target.value;

    setRegion(value);
    setSelectedRegionValue(value)
    setqueryParamsForRegionsTab({...queryParamsForRegionsTab, regionFilter: value });
  };

  const handleProjectSelect = (event: any) => { //
    const value = event.target.value;

    setProject(value);
    if (tabName === 'Regions') {
      setqueryParamsForRegionsTab({ ...queryParamsForRegionsTab, projectFilter: value });
    } else if (tabName === 'Division Overview') {
      setqueryParamsForDivisionalSpecificsCM({ projectFilter: value });
    }
  };

  const handleFindingSelect = (event: any) => {
    const value = event.target.value;

    setFinding(value);
    if (tabName === 'Regions') {
      setqueryParamsForRegionsTab({ ...queryParamsForRegionsTab, findingFilter: value });
    } else if (tabName === 'Division Overview') {
      setqueryParamsForDivisionalSpecificsCM({ findingFilter: value });
    }
  };

  const handleInspectionSelect = (event: any) => {
    const value = event.target.value;

    setInspection(value);
    if (tabName === 'Regions') {
      setqueryParamsForRegionsTab({ ...queryParamsForRegionsTab, inspectionFilter: value });
    } else if (tabName === 'Division Overview') {
      setqueryParamsForDivisionalSpecificsCM({ inspectionFilter: value });
    }
  };

  const handleDateRangeSelect = (event: any) => {
    const value = event.target.value;
    let defaultValue = "Year to Date"
    let formattedValue = {}
    let yearToDateValue = {
      minDate: new Date(`${currentYear}-01-01T00:00:00.000Z`),
      maxDate: new Date(),
    }

    if(value !== defaultValue){
      formattedValue = dateRangeList[value]
    }

    let dateRangeValue = value === defaultValue ? yearToDateValue : formattedValue;
    
    setDateRange(value);
    if (tabName === 'Regions') {
      setqueryParamsForRegionsTab({ ...queryParamsForRegionsTab, dateRangeFilter: dateRangeValue });
    } else if (tabName === 'Division Overview') {
      setqueryParamsForDivisionalSpecificsCM({ dateRangeFilter: dateRangeValue });
    }
  };

  const handleFindingThresholdChange = _.debounce((event: any) => {
    const value = Number(event.target.value);
    
    setSelectedOverdueThreshold(value)
    
    setFindingThresholdNumberOfDays(value)
    if (tabName === 'Regions') {
      setqueryParamsForRegionsTab({ ...queryParamsForRegionsTab, findingThresholdFilter: value });
    } else if (tabName === 'Division Overview') {
      setqueryParamsForDivisionalSpecificsCM({ findingThresholdFilter: value });
    }
  }, 500);

  const resetButtonHandler = () => {
    if (tabName === 'Regions') {
      setqueryParamsForRegionsTab({
        projectFilter: "All Project Types",
        inspectionFilter: "All Inspection Types",
        findingFilter: "All Finding Types",
        divisionFilter: "All Divisions"
      });
      setDivision("All Divisions");
      setFindingThresholdNumberOfDays(defaultFindingThresholdNumberOfDays)
    } else if (tabName === 'Division Overview') {
      setqueryParamsForDivisionalSpecificsCM({
        projectFilter: "All Project Types",
        inspectionFilter: "All Inspection Types",
        findingFilter: "All Finding Types",
        regionFilter: "All Regions"
      });
      setRegion("All Regions");
      setFindingThresholdNumberOfDays(defaultFindingThresholdNumberOfDays)
    }

    setProject("All Project Types");
    setFinding("All Finding Types");
    setInspection("All Inspection Types");
    setDateRange("Year to Date");
  };

  return (
    <div className='side-filter-menu'>
      <div className='side-filter-menu__menu'>
        <div
          className='side-filter-menu__cog-wrapper'
          onClick={() => setOpen(!open)}
        >
          <FontAwesomeIcon icon={faFilter} className='pad-left' />
        </div>

        <div
          className='side-filter-menu__drawer-wrapper'
          style={{ display: open ? 'block' : 'none' }}
        >
          <div className='side-filter-menu__drawer'>
            <section>
              <p>Filter</p>
              <hr />

              <div className='side-filter-menu__drawer-form-elements'>
                {tabName === 'Regions' ? (
                  <select id="region-type" value={region} onChange={handleRegionSelect}>
                    <option value="">All Regions</option>
                    {regionListForCM?.map((ele: any, index: number) => (
                      <option value={ele.id} key={index}>{ele.name}</option>
                    ))}
                  </select>
                )
                : (
                  <select id="division-type" value={division} onChange={handleDivisionSelect}>
                    <option value="">All Divisions</option>
                    {divisionListForCM?.map((ele: any, index: number) => (
                      <option value={ele.id} key={index}>{ele.name}</option>
                    ))}
                  </select>
                )}

                <select id="project-type" value={project} onChange={handleProjectSelect}>
                  <option value="">All Projects</option>
                  {projectTypeListForDashboardTabs?.map((ele: any, index: number) => (
                    <option value={ele.id} key={index}>{ele.name}</option>
                  ))}
                </select>

                <select id="finding-type" value={finding} onChange={handleFindingSelect}>
                  <option value="">All Findings</option>
                  {/* {findingTypeListForCM?.map((ele: any, index: number) => (
                    <option value={ele.name} key={index}>
                      {ele.name === "CA" ? "Corrective Action" :
                        ele.name === "MI" ? "Maintenance Item" :
                          ele.name}
                    </option>
                  ))} */}
                  
                  {findingTypeListForCM?.map((ele: any, index: number) => (
                    <option value={ele.name} key={index}>
                      {ele.name === "CA" ? "Corrective Action" :
                        ele.name === "MI" ? "Maintenance Item" :
                          ele.name}
                    </option>
                  ))}
                </select>

                <select id="inspection-type" value={inspection} onChange={handleInspectionSelect}>
                  <option value="">All Inspections</option>
                  {inspectionTypeListForCM?.map((ele: any, index: number) => (
                    <option value={ele.name} key={index}>{ele.name}</option>
                  ))}
                </select>
              </div>
            </section>

            <section>
              <p>Overdue Findings</p>
              <hr />
              <div className='side-filter-menu__drawer-form-elements side-filter-menu__overdue-findings-form-elements'>
                <label htmlFor="finding-threshold-days">Number of Days</label>
                <input id="finding-threshold-days" type="number" min="0" defaultValue={7} onChange={(event) => handleFindingThresholdChange(event)}/>
              </div>
            </section>

            <section>
              <p>Date Range</p>
              <hr />
              <div className='side-filter-menu__drawer-form-elements'>
                <select id="date-range-type" value={dateRange} onChange={handleDateRangeSelect}>
                  <option value="">Year to Date</option>
                  {Object.keys(dateRangeList)?.map((ele: any, index: number) => (
                    <option value={ele} key={index}>{ele}</option>
                  ))}
                </select>
              </div>
            </section>

            <div className="side-filter-menu__action-buttons">
              <Button primary style={{ visibility: "hidden" }}>
                Save
              </Button>
              <button onClick={resetButtonHandler}>
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideFilterMenu;
